import React, { useMemo } from 'react';
import { EuiBasicTable } from "@elastic/eui";
import { toDecimalString } from '../../../../../../../shared/utils/numbers';
import { useLanguage } from '../../../../../../../shared/hooks/Language';

const getFooterColumn = (items:any,field:string)=>{
    let total:number=0;
    items.map((item: any) => total+=item[field])
    return (
      <span>{toDecimalString(total,2)}</span>
    );
}

export const TableDetalle = (props:any) =>{
    const {translate} = useLanguage();
	const {data, tiposEmpresa}=props;

    const hayPrimas = useMemo(()=> data.filter((f:any)=> f.prima!==0).length>0,[data]);
    const hayFiniquitos = useMemo(()=> data.filter((f:any)=> f.finiquito!==0).length>0,[data]);
    const esSucursal = useMemo(()=>(tiposEmpresa.tipoEmpresa==='S' || tiposEmpresa.subTipoEmpresa==='S'),[tiposEmpresa])

	let columns:any = [
        {
            field: 'dni',
            name: '',
            truncateText: false,
            dataType: 'string',
            width:'120px'
        },
        {
            field: 'nombre',
            name: '',
            truncateText: true,
            dataType: 'string',
            width:'20%'
        },
        {
            field: 'salario',
            name: translate('salario'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'salario')
        },
		{
            field: 'ret_Hipot',
            name: translate('retencion-especial-acotado'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'ret_Hipot')
        },
		{
            field: 'irpf',
            name: translate('retencion-especial-irpf-acotado'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'irpf')
        },

		{
            field: 'salarioNetoFacturable',
            name: translate('salario-neto-facturable-acotado'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'salarioNetoFacturable')
        },
		{
            field: 'costo_ss',
            name: translate('seguridad-social-empresa'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'costo_ss')
        },
		{
            field: 'totalFacturaPagar',
            name: translate('total-factura'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'totalFacturaPagar')
        },
    ];

    if(esSucursal){
        columns.splice(5,0,{
            field: 'ss_Empleado',
            name: 'S.S.Empleado',
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'ss_Empleado')
        },
        {
            field: 'salarioNeto',
            name: 'Salario Neto',
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'salarioNeto')
        }
    )
    }

    if(hayPrimas){
        columns.splice(3,0,{
            field: 'prima',
            name: translate('prima'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'prima')
        })
    }

    if(hayFiniquitos){
        columns.splice(3,0,{
            field: 'finiquito',
            name: translate('finiquito'),
            dataType: 'number',
            align:'right',
            render:(value:number)=> toDecimalString(value,2),
            footer: ({ items }: { items: any[] }) => getFooterColumn(items,'finiquito')
        })
    }

    
	return (
        <EuiBasicTable
          className='table-detalle-factura-visualizar'
          tableCaption=""
          compressed
          items={data}
          columns={columns}
        />
      );
}